import React from "react";
import { withRouter } from "react-router-dom";

// Externals
import compose from "recompose/compose";
import { GlobalHotKeys } from "react-hotkeys";

// Redux
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as appStateActions from "redux/actions/appStateActions";

function GlobalHotKeys_(props) {
  const { children, showMaintasks, showSidebar, bosServerUnavailable } = props;

  const hotkeyMap = {
    TOGGLE_SHOWMAINTASKS: "ctrl+m",
    TOGGLE_SHOWSIDEBAR: "ctrl+shift+s",
    LOGOUT: "ctrl+shift+q",

    //ONLY FOR TESTING --- DISABLE FOR PRODUCTION USE
    TOGGLE_SHOWSERVERUNAVAILABLE: "ctrl+shift+ä",
  };

  const hotkeyHandlers = {
    TOGGLE_SHOWMAINTASKS: (e) => toggleShowMaintasks(e),
    TOGGLE_SHOWSIDEBAR: (e) => toggleShowSidebar(e),
    LOGOUT: (e) => logout(e),
    TOGGLE_SHOWSERVERUNAVAILABLE: (e) => toggleShowServerUnavailable(e),
  };

  const toggleShowMaintasks = (event) => {
    props.appStateActions.showMaintasks(!showMaintasks);
  };

  const toggleShowSidebar = (event) => {
    props.appStateActions.showSidebar(!showSidebar);
  };

  const logout = (event) => {
    props.history.push("/logout/1");
  };

  const toggleShowServerUnavailable = (event) => {
    props.appStateActions.setBosServerUnavailable(!bosServerUnavailable);
  };

  return (
    <GlobalHotKeys keyMap={hotkeyMap} handlers={hotkeyHandlers} allowChanges={true}>
      {children}
    </GlobalHotKeys>
  );
}

function mapStateToProps(state, ownProps) {
  return {
    showMaintasks: state.appState.showMaintasks,
    showSidebar: state.appState.showSidebar,
    bosServerUnavailable: state.appState.bosServerUnavailable,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    appStateActions: bindActionCreators(appStateActions, dispatch)
  };
}

export default compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(GlobalHotKeys_);
